import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "49.401",
  viewBox: "0 0 49.401 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M0 23.3h42.814L21.956 2.442 24.4-.003l25 24.95-25 25.05-2.494-2.495 20.71-20.71H0z"
  })]
});